export default "__VITE_ASSET__BtH5Cf3g__"